import {
  IMAGE,
  BUTTON,
  BLUEBUTTONWITHRAD,
  WHITEBUTTON,
  WHITEBUTTONWITHRAD,
  BUTTONWITHOUTBORDER,
  ADDHEADING,
  ADDSUBHEADING,
  ADDBODY,
  RECTANGLE,
  CIRCLE,
  TRIANGLE,
  POLYGON,
  HEXAGON,
  SCROLLBAR,
  addHeading,
  addSubHeading,
  addBody,
  button,
  rectangleShape,
  circleShape,
  triangleShape,
  polygonShape,
  hexagonShape,
  image,
  BlueButtonWithRad,
  WhiteButton,
  WhiteButtonWithRad,
  ButtonWithoutBorder,
  scrollbar,
  reference,
  footnotes,
  REFERENCE,
  FOOTNOTES,
  abbreviation,
  ABBREVIATION,
} from "../../Uitls/ComponentType";

export const createEditorComponentTypeFactory = ({
  count,
  setCountZindex,
  layerSequence,
  getHeightestZindex,
  getMaxlayerNameCount,
  isAspectRatioLocked,
  canvasDimension,
  editComponent,
  imageOnCanvas,
}) => {
  const componentType = {
    [ADDHEADING]: function (
      coOrdinates,
      ev,
      addHdng = addHeading,
      cnt = count,
    ) {
      let cntZ = addHdng.zIndex || getHeightestZindex();
      setCountZindex(cntZ);
      let x = layerSequence("Text");

      let layerCnt;
      if (x.length > 0) {
        layerCnt = getMaxlayerNameCount("Text") + 1;
      } else {
        layerCnt = x.length + 1;
      }

      return {
        id: "Text" + cnt,
        componentType: "Text",
        textComponentType: {
          addContent: "AddHeading",
        },

        froalaText: addHdng.froalaText,
        componentStyles: {
          left: coOrdinates.x,
          top: coOrdinates.y,
          width: addHdng.width,
          height: addHdng.height,
          bottom: addHdng.height + coOrdinates.y,
          right: addHdng.width + coOrdinates.x,
          vMiddle: coOrdinates.x + addHdng.width / 2,
          hMiddle: coOrdinates.y + addHdng.height / 2,
          fontFamily: addHdng.fontFamily,
          fontLink: addHdng.fontLink || "",
          fontSize: addHdng.fontSize,
          textAlign: addHdng.textAlign,
          color: addHdng.color,
          listStyletype: addHdng.listStyletype,
          fontWeight: addHdng.fontWeight,
          fontWeightBold: addHdng.fontWeightBold,
          textDecUnderline: addHdng.textDecUnderline,
          letterSpacing: addHdng.letterSpacing,
          lineHeight: addHdng.lineHeight,
          fontStyle: addHdng.fontStyle,
          textTransform: addHdng.textTransform,
          textDecoration: addHdng.textDecoration,
          underlineClick: addHdng.underlineClick,
          strikeThroughClicked: addHdng.strikeThroughClicked,
          italicClick: addHdng.italicClick,
          boldClick: addHdng.boldClick,
          uppercaseClicked: addHdng.uppercaseClicked,
          zIndex: cntZ,
          icon: addHdng.icon,
          BGColor: "#a9e4bc",
          rotation: addHdng.rotation,
          ease: addHdng.ease,
          transform: addHdng.scale,
          targetLink: addHdng.targetLink,
          aspectLock: isAspectRatioLocked,
          cursor: addHdng.targetLink !== "https://" ? "pointer" : "default",
          lockBoolean: addHdng.lockBoolean,
          hideBoolean: addHdng.hideBoolean,
          opacity: addHdng.hideBoolean ? 0 : 1,
          toggleScroll: addHdng.toggleScroll,
          thumbHeight: addHdng.thumbHeight,
          thumbWidth: addHdng.thumbWidth,
          arrowWidth: addHdng.arrowWidth,
          arrowHeight: addHdng.arrowHeight,
          trackWidth: addHdng.trackWidth,
          trackHeight: addHdng.trackHeight,
          trackRadius: addHdng.trackRadius,
          thumbColor: addHdng.thumbColor,
          thumbRight: addHdng.thumbRight,
          trackRight: addHdng.trackRight,
          scrollThumbBg: addHdng.scrollThumbBg,
          scrollUpArrowbg: addHdng.scrollUpArrowbg,
          scrollDownArrowbg: addHdng.scrollDownArrowbg,
          textBgColor: addHdng.textBgColor,
          datafontSize: addHdng.datafontSize,
          selectedFontStyle: addHdng.selectedFontStyle,
          selectedId: addHdng.selectedId,
          selectedIdnumberList: addHdng.selectedIdnumberList,
          autoScroll: addHdng.autoScroll,
          expandAndClose: addHdng.expandAndClose,
          expandText: addHdng.expandText,
          expandTextUpdated: addHdng.expandText,
          closeTextUpdated: addHdng.closeText,
          closeText: addHdng.closeText,
          leftalignClick: addHdng.leftalignClick,
          rightAlignClick: addHdng.rightAlignClick,
          centerAlignClick: addHdng.centerAlignClick,
          listTypeNumberClick: addHdng.listTypeNumberClick,
          listTypediscClick: addHdng.listTypediscClick,
          expandClose: { ...addHdng.expandClose },
          layerName:
            addHdng.layerName === "Text"
              ? addHdng.layerName + layerCnt
              : addHdng.layerName,
          thumbRight: addHdng.thumbRight,
          layerNameUpdated:
            addHdng.layerName === "Text"
              ? addHdng.layerName + layerCnt
              : addHdng.layerName,
          layerWidth: addHdng.layerWidth,
        },

        keyFrames: addHdng.keyFrames || [],
        transformOriginX: addHdng.transformOriginX,
        tranformOriginY: addHdng.transformOriginY,
        transformOriginZ: addHdng.transformOriginZ,
      };
    },
    [ADDSUBHEADING]: function (
      coOrdinates,
      ev,
      addSbHdng = addSubHeading,
      cnt = count,
    ) {
      let cntZ = addSbHdng.zIndex || getHeightestZindex();
      setCountZindex(cntZ);
      let x = layerSequence("Text");
      let layerCnt;
      if (x.length > 0) {
        layerCnt = getMaxlayerNameCount("Text") + 1;
      } else {
        layerCnt = x.length + 1;
      }

      return {
        id: "Text" + cnt,
        componentType: "Text",
        textComponentType: {
          addContent: "AddSubHeading",
        },
        froalaText: addSbHdng.froalaText,

        componentStyles: {
          left: coOrdinates.x,
          top: coOrdinates.y,
          width: addSbHdng.width,
          height: addSbHdng.height,
          bottom: coOrdinates.y + addSbHdng.height,
          right: addSbHdng.width + coOrdinates.x,
          vMiddle: coOrdinates.x + addSbHdng.width / 2,
          hMiddle: coOrdinates.y + addSbHdng.height / 2,
          fontFamily: addSbHdng.fontFamily,
          fontLink: addSbHdng.fontLink || "",
          fontSize: addSbHdng.fontSize,

          textAlign: addSbHdng.textAlign,
          color: addSbHdng.color,
          listStyletype: addSbHdng.listStyletype,
          fontWeight: addSbHdng.fontWeight,
          fontWeightBold: addSbHdng.fontWeightBold,
          textDecUnderline: addSbHdng.textDecUnderline,
          letterSpacing: addSbHdng.letterSpacing,
          lineHeight: addSbHdng.lineHeight,
          fontStyle: addSbHdng.fontStyle,
          textTransform: addSbHdng.textTransform,
          textDecoration: addSbHdng.textDecoration,
          underlineClick: addSbHdng.underlineClick,
          strikeThroughClicked: addSbHdng.strikeThroughClicked,
          italicClick: addSbHdng.italicClick,
          boldClick: addSbHdng.boldClick,
          uppercaseClicked: addSbHdng.uppercaseClicked,
          zIndex: cntZ,
          icon: addSbHdng.icon,
          BGColor: "#a9e4bc",
          rotation: addSbHdng.rotation,
          ease: addSbHdng.ease,
          aspectLock: isAspectRatioLocked,
          targetLink: addSbHdng.targetLink,
          cursor: addSbHdng.targetLink !== "https://" ? "pointer" : "default",
          lockBoolean: addSbHdng.lockBoolean,
          hideBoolean: addSbHdng.hideBoolean,
          opacity: addSbHdng.hideBoolean ? 0 : 1,
          toggleScroll: addSbHdng.toggleScroll,
          thumbHeight: addSbHdng.thumbHeight,
          thumbWidth: addSbHdng.thumbWidth,
          arrowWidth: addSbHdng.arrowWidth,
          arrowHeight: addSbHdng.arrowHeight,
          trackWidth: addSbHdng.trackWidth,
          trackHeight: addSbHdng.trackHeight,
          trackRadius: addSbHdng.trackRadius,
          thumbColor: addSbHdng.thumbColor,
          thumbRight: addSbHdng.thumbRight,
          trackRight: addSbHdng.trackRight,
          scrollThumbBg: addSbHdng.scrollThumbBg,
          scrollUpArrowbg: addSbHdng.scrollUpArrowbg,
          scrollDownArrowbg: addSbHdng.scrollDownArrowbg,
          textBgColor: addSbHdng.textBgColor,
          datafontSize: addSbHdng.datafontSize,
          selectedFontStyle: addSbHdng.selectedFontStyle,
          selectedId: addSbHdng.selectedId,
          selectedIdnumberList: addSbHdng.selectedIdnumberList,

          autoScroll: addSbHdng.autoScroll,
          expandAndClose: addSbHdng.expandAndClose,
          expandText: addSbHdng.expandText,
          closeText: addSbHdng.closeText,
          expandTextUpdated: addSbHdng.expandText,
          closeTextUpdated: addSbHdng.closeText,
          expandClose: { ...addSbHdng.expandClose },
          layerName:
            addSbHdng.layerName === "Text"
              ? addSbHdng.layerName + layerCnt
              : addSbHdng.layerName,
          thumbRight: addSbHdng.thumbRight,
          layerNameUpdated:
            addSbHdng.layerName === "Text"
              ? addSbHdng.layerName + layerCnt
              : addSbHdng.layerName,
          layerWidth: addSbHdng.layerWidth,
          transformOriginX: addSbHdng.transformOriginX,
          tranformOriginY: addSbHdng.transformOriginY,
          transformOriginZ: addSbHdng.transformOriginZ,
        },

        keyFrames: addSbHdng.keyFrames || [],
      };
    },
    [ADDBODY]: function (coOrdinates, ev, addBdy = addBody, cnt = count) {
      let cntZ = addBdy.zIndex || getHeightestZindex();
      setCountZindex(cntZ);
      let x = layerSequence("Text");
      let layerCnt;
      if (x.length > 0) {
        layerCnt = getMaxlayerNameCount("Text") + 1;
      } else {
        layerCnt = x.length + 1;
      }

      return {
        id: "Text" + cnt,
        componentType: "Text",
        textComponentType: {
          addContent: "addBody",
        },
        moduleIdIdentifier: addBdy.moduleIdIdentifier,
        froalaText: addBdy.froalaText,
        componentId: addBdy.componentId,
        reusableTextId: addBdy.reusableTextId,
        titleId: addBdy.titleId,
        matchTextId: addBdy.matchTextId,
        matchTextFootnotes: addBdy.matchTextFootnotes,
        matchTextReferences: addBdy.matchTextReferences,
        claimId: addBdy.claimId,
        rcClaimIds: addBdy.rcClaimIds,
        matchTextSymbol: addBdy.matchTextSymbol,
        rcSybmols: addBdy.rcSybmols,
        claimFootnotes: addBdy.claimFootnotes,
        claimAbbreviation: addBdy.claimAbbreviation,
        footnoteSymbol: addBdy.footnoteSymbol,
        claimReferences: addBdy.claimReferences,
        componentStyles: {
          left: coOrdinates.x,
          top: coOrdinates.y,
          width: addBdy.width,
          height: addBdy.height,
          bottom: addBdy.height + coOrdinates.y,
          right: addBdy.width + coOrdinates.x,
          vMiddle: coOrdinates.x + addBdy.width / 2,
          hMiddle: coOrdinates.y + addBdy.height / 2,
          fontFamily: addBdy.fontFamily,
          fontLink: addBdy.fontLink || "",
          fontSize: addBdy.fontSize,

          textAlign: addBdy.textAlign,
          color: addBdy.color,
          listStyletype: addBdy.listStyletype,
          fontWeight: addBdy.fontWeight,
          fontWeightBold: addBdy.fontWeightBold,
          textDecUnderline: addBdy.textDecUnderline,
          letterSpacing: addBdy.letterSpacing,
          lineHeight: addBdy.lineHeight,
          fontStyle: addBdy.fontStyle,
          textTransform: addBdy.textTransform,
          textDecoration: addBdy.textDecoration,
          underlineClick: addBdy.underlineClick,
          strikeThroughClicked: addBdy.strikeThroughClicked,
          italicClick: addBdy.italicClick,
          boldClick: addBdy.boldClick,
          uppercaseClicked: addBdy.uppercaseClicked,
          zIndex: cntZ,
          icon: addBdy.icon,
          BGColor: "#a9e4bc",
          rotation: addBdy.rotation,
          ease: addBdy.ease,
          targetLink: addBdy.targetLink,
          aspectLock: isAspectRatioLocked,
          lockBoolean: addBdy.lockBoolean,
          hideBoolean: addBdy.hideBoolean,
          opacity: addBdy.hideBoolean ? 0 : 1,
          toggleScroll: addBdy.toggleScroll,
          thumbHeight: addBdy.thumbHeight,
          thumbWidth: addBdy.thumbWidth,
          arrowWidth: addBdy.arrowWidth,
          arrowHeight: addBdy.arrowHeight,
          trackWidth: addBdy.trackWidth,
          trackHeight: addBdy.trackHeight,
          trackRadius: addBdy.trackRadius,
          thumbColor: addBdy.thumbColor,
          scrollThumbBg: addBdy.scrollThumbBg,
          scrollUpArrowbg: addBdy.scrollUpArrowbg,
          scrollDownArrowbg: addBdy.scrollDownArrowbg,
          textBgColor: addBdy.textBgColor,
          datafontSize: addBdy.datafontSize,
          selectedFontStyle: addBdy.selectedFontStyle,
          selectedId: addBdy.selectedId,
          selectedIdnumberList: addBdy.selectedIdnumberList,

          autoScroll: addBdy.autoScroll,
          expandAndClose: addBdy.expandAndClose,
          expandText: addBdy.expandText,
          closeText: addBdy.closeText,
          thumbRight: addBdy.thumbRight,
          trackRight: addBdy.trackRight,
          expandTextUpdated: addBdy.expandText,
          closeTextUpdated: addBdy.closeText,
          expandClose: { ...addBdy.expandClose },
          layerName:
            addBdy.layerName === "Text"
              ? addBdy.layerName + layerCnt
              : addBdy.layerName,
          thumbRight: addBdy.thumbRight,
          layerNameUpdated:
            addBdy.layerName === "Text"
              ? addBdy.layerName + layerCnt
              : addBdy.layerName,
          layerWidth: addBdy.layerWidth,
          transformOriginX: addBdy.transformOriginX,
          tranformOriginY: addBdy.transformOriginY,
          transformOriginZ: addBdy.transformOriginZ,
        },

        keyFrames: addBdy.keyFrames || [],
      };
    },
    [BUTTON]: function (coOrdinates, ev, but = button, cnt = count) {
      let cntZ = but.zIndex || getHeightestZindex();
      setCountZindex(cntZ);
      let x = layerSequence("Button");
      let layerCnt;
      if (x.length > 0) {
        layerCnt = getMaxlayerNameCount("Button") + 1;
      } else {
        layerCnt = x.length + 1;
      }
      return {
        id: "Button" + cnt,
        componentType: "Button",
        textComponentType: {
          addContent: "button",
        },
        //  datafontSize: but.fontSize,
        froalaText: but.froalaText,
        componentStyles: {
          left: coOrdinates.x,
          top: coOrdinates.y,
          width: but.width,
          height: but.height,
          bottom: coOrdinates.y + but.height,
          right: but.width + coOrdinates.x,
          vMiddle: coOrdinates.x + but.width / 2,
          hMiddle: coOrdinates.y + but.height / 2,
          fontFamily: but.fontFamily,
          fontLink: but.fontLink || "",
          fontSize: but.fontSize,
          textAlign: but.textAlign,
          color: but.color,
          listStyleType: but.listStyletype,
          fontWeight: but.fontWeight,
          fontWeightBold: but.fontWeightBold,
          textDecUnderline: but.textDecUnderline,
          letterSpacing: but.letterSpacing,
          lineHeight: but.lineHeight,
          fontStyle: but.fontStyle,
          textTransform: but.textTransform,
          textDecoration: but.textDecoration,
          underlineClick: but.underlineClick,
          strikeThroughClicked: but.strikeThroughClicked,
          italicClick: but.italicClick,
          boldClick: but.boldClick,
          uppercaseClicked: but.uppercaseClicked,
          zIndex: cntZ,
          backgroundColor: but.backgroundColor,
          border: but.border,
          targetLink: but.targetLink,
          paddingTop: but.paddingTop,
          paddingRight: but.paddingRight,
          paddingBottom: but.paddingBottom,
          paddingLeft: but.paddingLeft,
          borderTopLeftRadius: but.borderTopLeftRadius,
          borderTopRightRadius: but.borderTopRightRadius,
          borderBottomLeftRadius: but.borderBottomLeftRadius,
          borderBottomRightRadius: but.borderBottomRightRadius,
          icon: but.icon,
          BGColor: "#f8dfc8",
          rotation: but.rotation,
          ease: but.ease,
          aspectLock: isAspectRatioLocked,
          cursor: but.targetLink !== "https://" ? "pointer" : "default",
          lockBoolean: but.lockBoolean,
          hideBoolean: but.hideBoolean,
          opacity: but.hideBoolean ? 0 : 1,
          datafontSize: but.datafontSize,
          selectedFontStyle: but.selectedFontStyle,
          selectedId: but.selectedId,
          selectedIdnumberList: but.selectedIdnumberList,

          layerName:
            but.layerName === "Button"
              ? but.layerName + layerCnt
              : but.layerName,
          layerNameUpdated:
            but.layerName === "Button"
              ? but.layerName + layerCnt
              : but.layerName,
          layerWidth: but.layerWidth,
          transformOriginX: but.transformOriginX,
          tranformOriginY: but.transformOriginY,
          transformOriginZ: but.transformOriginZ,
        },

        keyFrames: but.keyFrames || [],
      };
    },
    [BLUEBUTTONWITHRAD]: function (
      coOrdinates,
      ev,
      but = BlueButtonWithRad,
      cnt = count,
    ) {
      let cntZ = but.zIndex || getHeightestZindex();
      setCountZindex(cntZ);
      let x = layerSequence("Button");
      let layerCnt;
      if (x.length > 0) {
        layerCnt = getMaxlayerNameCount("Button") + 1;
      } else {
        layerCnt = x.length + 1;
      }
      return {
        id: "Button" + cnt,
        componentType: "Button",
        textComponentType: {
          addContent: "Button",
        },
        //  datafontSize: but.fontSize,
        froalaText: but.froalaText,
        componentStyles: {
          left: coOrdinates.x,
          top: coOrdinates.y,
          width: but.width,
          height: but.height,
          bottom: coOrdinates.y + but.height,
          right: but.width + coOrdinates.x,
          vMiddle: coOrdinates.x + but.width / 2,
          hMiddle: coOrdinates.y + but.height / 2,
          fontFamily: but.fontFamily,
          fontLink: but.fontLink || "",
          fontSize: but.fontSize,
          textAlign: but.textAlign,
          color: but.color,
          listStyleType: but.listStyletype,
          fontWeight: but.fontWeight,
          fontWeightBold: but.fontWeightBold,
          textDecUnderline: but.textDecUnderline,
          letterSpacing: but.letterSpacing,
          lineHeight: but.lineHeight,
          fontStyle: but.fontStyle,
          textTransform: but.textTransform,
          textDecoration: but.textDecoration,
          underlineClick: but.underlineClick,
          strikeThroughClicked: but.strikeThroughClicked,
          italicClick: but.italicClick,
          boldClick: but.boldClick,
          uppercaseClicked: but.uppercaseClicked,
          zIndex: cntZ,
          backgroundColor: but.backgroundColor,
          border: but.border,
          targetLink: but.targetLink,
          paddingTop: but.paddingTop,
          paddingRight: but.paddingRight,
          paddingBottom: but.paddingBottom,
          paddingLeft: but.paddingLeft,
          borderTopLeftRadius: but.borderTopLeftRadius,
          borderTopRightRadius: but.borderTopRightRadius,
          borderBottomLeftRadius: but.borderBottomLeftRadius,
          borderBottomRightRadius: but.borderBottomRightRadius,
          icon: but.icon,
          BGColor: "#f8dfc8",
          rotation: but.rotation,
          ease: but.ease,
          aspectLock: isAspectRatioLocked,
          cursor: but.targetLink !== "http://" ? "pointer" : "default",
          lockBoolean: but.lockBoolean,
          hideBoolean: but.hideBoolean,
          opacity: but.hideBoolean ? 0 : 1,
          datafontSize: but.datafontSize,
          selectedFontStyle: but.selectedFontStyle,
          selectedId: but.selectedId,
          layerName:
            but.layerName === "Button"
              ? but.layerName + layerCnt
              : but.layerName,
          layerNameUpdated:
            but.layerName === "Button"
              ? but.layerName + layerCnt
              : but.layerName,
          layerWidth: but.layerWidth,
          transformOriginX: but.transformOriginX,
          tranformOriginY: but.transformOriginY,
          transformOriginZ: but.transformOriginZ,
        },

        keyFrames: but.keyFrames || [],
      };
    },
    [WHITEBUTTON]: function (coOrdinates, ev, but = WhiteButton, cnt = count) {
      let cntZ = but.zIndex || getHeightestZindex();
      setCountZindex(cntZ);
      let x = layerSequence("Button");
      let layerCnt;
      if (x.length > 0) {
        layerCnt = getMaxlayerNameCount("Button") + 1;
      } else {
        layerCnt = x.length + 1;
      }
      return {
        id: "Button" + cnt,
        componentType: "Button",
        textComponentType: {
          addContent: "Button",
        },
        froalaText: but.froalaText,
        componentStyles: {
          left: coOrdinates.x,
          top: coOrdinates.y,
          width: but.width,
          height: but.height,
          bottom: coOrdinates.y + but.height,
          right: but.width + coOrdinates.x,
          vMiddle: coOrdinates.x + but.width / 2,
          hMiddle: coOrdinates.y + but.height / 2,
          fontFamily: but.fontFamily,
          fontLink: but.fontLink || "",
          fontSize: but.fontSize,
          textAlign: but.textAlign,
          color: but.color,
          listStyleType: but.listStyletype,
          fontWeight: but.fontWeight,
          fontWeightBold: but.fontWeightBold,
          textDecUnderline: but.textDecUnderline,
          letterSpacing: but.letterSpacing,
          lineHeight: but.lineHeight,
          fontStyle: but.fontStyle,
          textTransform: but.textTransform,
          textDecoration: but.textDecoration,
          underlineClick: but.underlineClick,
          strikeThroughClicked: but.strikeThroughClicked,
          italicClick: but.italicClick,
          boldClick: but.boldClick,
          uppercaseClicked: but.uppercaseClicked,
          zIndex: cntZ,
          backgroundColor: but.backgroundColor,
          border: but.border,
          targetLink: but.targetLink,
          paddingTop: but.paddingTop,
          paddingRight: but.paddingRight,
          paddingBottom: but.paddingBottom,
          paddingLeft: but.paddingLeft,
          borderTopLeftRadius: but.borderTopLeftRadius,
          borderTopRightRadius: but.borderTopRightRadius,
          borderBottomLeftRadius: but.borderBottomLeftRadius,
          borderBottomRightRadius: but.borderBottomRightRadius,
          icon: but.icon,
          BGColor: "#f8dfc8",
          rotation: but.rotation,
          ease: but.ease,
          aspectLock: isAspectRatioLocked,
          cursor: but.targetLink !== "http://" ? "pointer" : "default",
          lockBoolean: but.lockBoolean,
          hideBoolean: but.hideBoolean,
          opacity: but.hideBoolean ? 0 : 1,
          datafontSize: but.datafontSize,
          selectedFontStyle: but.selectedFontStyle,
          selectedId: but.selectedId,
          layerName:
            but.layerName === "Button"
              ? but.layerName + layerCnt
              : but.layerName,
          layerNameUpdated:
            but.layerName === "Button"
              ? but.layerName + layerCnt
              : but.layerName,
          layerWidth: but.layerWidth,
          transformOriginX: but.transformOriginX,
          tranformOriginY: but.transformOriginY,
          transformOriginZ: but.transformOriginZ,
        },

        keyFrames: but.keyFrames || [],
      };
    },
    [WHITEBUTTONWITHRAD]: function (
      coOrdinates,
      ev,
      but = WhiteButtonWithRad,

      cnt = count,
    ) {
      let cntZ = but.zIndex || getHeightestZindex();
      setCountZindex(cntZ);
      let x = layerSequence("Button");
      let layerCnt;
      if (x.length > 0) {
        layerCnt = getMaxlayerNameCount("Button") + 1;
      } else {
        layerCnt = x.length + 1;
      }
      return {
        id: "Button" + cnt,
        componentType: "Button",
        textComponentType: {
          addContent: "Button",
        },
        froalaText: but.froalaText,
        componentStyles: {
          left: coOrdinates.x,
          top: coOrdinates.y,
          width: but.width,
          height: but.height,
          bottom: coOrdinates.y + but.height,
          right: but.width + coOrdinates.x,
          vMiddle: coOrdinates.x + but.width / 2,
          hMiddle: coOrdinates.y + but.height / 2,
          fontFamily: but.fontFamily,
          fontLink: but.fontLink || "",
          fontSize: but.fontSize,
          textAlign: but.textAlign,
          color: but.color,
          listStyleType: but.listStyletype,
          fontWeight: but.fontWeight,
          fontWeightBold: but.fontWeightBold,
          textDecUnderline: but.textDecUnderline,
          letterSpacing: but.letterSpacing,
          lineHeight: but.lineHeight,
          fontStyle: but.fontStyle,
          textTransform: but.textTransform,
          textDecoration: but.textDecoration,
          underlineClick: but.underlineClick,
          strikeThroughClicked: but.strikeThroughClicked,
          italicClick: but.italicClick,
          boldClick: but.boldClick,
          uppercaseClicked: but.uppercaseClicked,
          zIndex: cntZ,
          backgroundColor: but.backgroundColor,
          border: but.border,
          targetLink: but.targetLink,
          paddingTop: but.paddingTop,
          paddingRight: but.paddingRight,
          paddingBottom: but.paddingBottom,
          paddingLeft: but.paddingLeft,
          borderTopLeftRadius: but.borderTopLeftRadius,
          borderTopRightRadius: but.borderTopRightRadius,
          borderBottomLeftRadius: but.borderBottomLeftRadius,
          borderBottomRightRadius: but.borderBottomRightRadius,
          icon: but.icon,
          BGColor: "#f8dfc8",
          rotation: but.rotation,
          ease: but.ease,
          aspectLock: isAspectRatioLocked,
          cursor: but.targetLink !== "http://" ? "pointer" : "default",
          lockBoolean: but.lockBoolean,
          hideBoolean: but.hideBoolean,
          opacity: but.hideBoolean ? 0 : 1,
          datafontSize: but.datafontSize,
          selectedFontStyle: but.selectedFontStyle,
          selectedId: but.selectedId,
          layerName:
            but.layerName === "Button"
              ? but.layerName + layerCnt
              : but.layerName,
          layerNameUpdated:
            but.layerName === "Button"
              ? but.layerName + layerCnt
              : but.layerName,
          layerWidth: but.layerWidth,
          transformOriginX: but.transformOriginX,
          tranformOriginY: but.transformOriginY,
          transformOriginZ: but.transformOriginZ,
        },

        keyFrames: but.keyFrames || [],
      };
    },
    [BUTTONWITHOUTBORDER]: function (
      coOrdinates,
      ev,
      but = ButtonWithoutBorder,
      cnt = count,
    ) {
      let cntZ = but.zIndex || getHeightestZindex();
      setCountZindex(cntZ);
      let x = layerSequence("Button");
      let layerCnt;
      if (x.length > 0) {
        layerCnt = getMaxlayerNameCount("Button") + 1;
      } else {
        layerCnt = x.length + 1;
      }
      return {
        id: "Button" + cnt,
        componentType: "Button",
        textComponentType: {
          addContent: "Button",
        },
        froalaText: but.froalaText,
        componentStyles: {
          left: coOrdinates.x,
          top: coOrdinates.y,
          width: but.width,
          height: but.height,
          bottom: coOrdinates.y + but.height,
          right: but.width + coOrdinates.x,
          vMiddle: coOrdinates.x + but.width / 2,
          hMiddle: coOrdinates.y + but.height / 2,
          fontFamily: but.fontFamily,
          fontLink: but.fontLink || "",
          fontSize: but.fontSize,
          textAlign: but.textAlign,
          color: but.color,
          listStyleType: but.listStyletype,
          fontWeight: but.fontWeight,
          fontWeightBold: but.fontWeightBold,
          textDecUnderline: but.textDecUnderline,
          letterSpacing: but.letterSpacing,
          lineHeight: but.lineHeight,
          fontStyle: but.fontStyle,
          textTransform: but.textTransform,
          textDecoration: but.textDecoration,
          underlineClick: but.underlineClick,
          strikeThroughClicked: but.strikeThroughClicked,
          italicClick: but.italicClick,
          boldClick: but.boldClick,
          uppercaseClicked: but.uppercaseClicked,
          zIndex: cntZ,
          backgroundColor: but.backgroundColor,
          border: but.border,
          targetLink: but.targetLink,
          paddingTop: but.paddingTop,
          paddingRight: but.paddingRight,
          paddingBottom: but.paddingBottom,
          paddingLeft: but.paddingLeft,
          borderTopLeftRadius: but.borderTopLeftRadius,
          borderTopRightRadius: but.borderTopRightRadius,
          borderBottomLeftRadius: but.borderBottomLeftRadius,
          borderBottomRightRadius: but.borderBottomRightRadius,
          icon: but.icon,
          BGColor: "#f8dfc8",
          rotation: but.rotation,
          ease: but.ease,
          aspectLock: isAspectRatioLocked,
          cursor: but.targetLink !== "http://" ? "pointer" : "default",
          lockBoolean: but.lockBoolean,
          hideBoolean: but.hideBoolean,
          opacity: but.hideBoolean ? 0 : 1,
          datafontSize: but.datafontSize,
          selectedFontStyle: but.selectedFontStyle,
          selectedId: but.selectedId,
          layerName:
            but.layerName === "Button"
              ? but.layerName + layerCnt
              : but.layerName,
          layerNameUpdated:
            but.layerName === "Button"
              ? but.layerName + layerCnt
              : but.layerName,
          layerWidth: but.layerWidth,
          transformOriginX: but.transformOriginX,
          tranformOriginY: but.transformOriginY,
          transformOriginZ: but.transformOriginZ,
        },

        keyFrames: but.keyFrames || [],
      };
    },

    [IMAGE]: function (coOrdinates, ev, url) {
      var img = new Image();
      img.src = url;
      const subtractSize = 20;
      let dimension = { ...canvasDimension };
      if (editComponent) {
        dimension.height = 200;
        dimension.width = 200;
      } else {
        dimension = { ...canvasDimension };
      }
      let NewHeight = canvasDimension.height - subtractSize;
      let NewWidth = canvasDimension.width - subtractSize;
      let aspectRatio = 1;
      img.onload = function () {
        let imgWidth = img.width;
        let imgHeight = img.height;
        aspectRatio = imgWidth / imgHeight;

        if (canvasDimension.width < 310)
          if (
            canvasDimension.height >= imgHeight &&
            canvasDimension.width >= imgWidth
          ) {
            NewHeight = imgHeight;
            NewWidth = imgWidth;
          } else if (imgHeight > imgWidth) {
            NewWidth = (imgWidth / imgHeight) * NewHeight;
            if (NewWidth > canvasDimension.width) {
              NewWidth = canvasDimension.width;
              NewHeight = (imgHeight / imgWidth) * NewWidth;
            } else if (NewHeight > canvasDimension.height) {
              NewHeight = NewHeight;

              NewWidth = (imgWidth / imgHeight) * NewHeight;
            }
          } else if (imgWidth > imgHeight || imgHeight === imgWidth) {
            NewWidth = canvasDimension.width;
            NewHeight = (imgHeight / imgWidth) * NewWidth;

            if (NewHeight > canvasDimension.height) {
              NewHeight = canvasDimension.height;
              NewWidth = (imgWidth / imgHeight) * NewHeight;
            }
          } else {
            NewHeight = imgHeight;
            NewWidth = imgWidth;
          }
        else {
          if (
            canvasDimension.height >= imgHeight &&
            canvasDimension.width >= imgWidth
          ) {
            NewHeight = imgHeight;
            NewWidth = imgWidth;
          } else if (imgHeight > imgWidth) {
            NewWidth = (imgWidth / imgHeight) * NewHeight;
            if (NewWidth > canvasDimension.width) {
              NewWidth = canvasDimension.width;
              NewHeight = (imgHeight / imgWidth) * NewWidth;
            } else if (NewHeight > canvasDimension.height) {
              NewHeight = canvasDimension.height;

              NewWidth = (imgWidth / imgHeight) * NewHeight;
            }
          } else if (imgWidth > imgHeight || imgHeight === imgWidth) {
            NewWidth = 200;
            NewHeight = (imgHeight / imgWidth) * NewWidth;

            if (NewHeight > canvasDimension.height) {
              NewHeight = canvasDimension.height;
              NewWidth = (imgWidth / imgHeight) * NewHeight;
            }
          } else {
            NewHeight = imgHeight;
            NewWidth = imgWidth;
          }
        }

        imageOnCanvas(
          undefined,
          url,
          coOrdinates.x,
          coOrdinates.y,
          "fileName",
          image,
          NewWidth,
          NewHeight,
          count,
          aspectRatio,
        );
      };
    },

    [RECTANGLE]: function (
      coOrdinates,
      ev,
      rectangle = rectangleShape,
      cnt = count,
    ) {
      let cntZ = rectangle.zIndex || getHeightestZindex();
      setCountZindex(cntZ);
      let x = layerSequence("Shape");
      let layerCnt;
      if (x.length > 0) {
        layerCnt = getMaxlayerNameCount("Shape") + 1;
      } else {
        layerCnt = x.length + 1;
      }
      return {
        id: "rectangleShape" + cnt,
        componentType: "Shape",
        textComponentType: {
          addContent: "rectangleShape",
        },
        froalaText: "",
        componentStyles: {
          left: coOrdinates.x,
          top: coOrdinates.y,
          oldLeft: coOrdinates.x,
          oldRight: coOrdinates.y,
          width: rectangle.width,
          height: rectangle.height,
          bottom: coOrdinates.y + rectangle.height,
          right: rectangle.width + coOrdinates.x,
          vMiddle: coOrdinates.x + rectangle.width / 2,
          hMiddle: coOrdinates.y + rectangle.height / 2,
          zIndex: cntZ,
          backgroundColor: rectangle.backgroundColor,
          border: rectangle.border,
          paddingTop: rectangle.paddingTop,
          paddingRight: rectangle.paddingRight,
          paddingBottom: rectangle.paddingBottom,
          paddingLeft: rectangle.paddingLeft,
          borderTopLeftRadius: rectangle.borderTopLeftRadius,
          borderTopRightRadius: rectangle.borderTopRightRadius,
          borderBottomLeftRadius: rectangle.borderBottomLeftRadius,
          borderBottomRightRadius: rectangle.borderBottomRightRadius,
          icon: rectangle.icon,
          BGColor: "#ceb5b7",
          rotation: rectangle.rotation,
          aspectLock: isAspectRatioLocked,
          lockBoolean: rectangle.lockBoolean,
          hideBoolean: rectangle.hideBoolean,
          opacity: rectangle.hideBoolean ? 0 : 1,
          compOpacity: rectangle.compOpacity,
          layerName:
            rectangle.layerName === "Shape"
              ? rectangle.layerName + layerCnt
              : rectangle.layerName,
          layerNameUpdated:
            rectangle.layerName === "Shape"
              ? rectangle.layerName + layerCnt
              : rectangle.layerName,
          layerWidth: rectangle.layerWidth,
          transformOriginX: rectangle.transformOriginX,
          tranformOriginY: rectangle.transformOriginY,
          transformOriginZ: rectangle.transformOriginZ,
        },

        keyFrames: rectangle.keyFrames || [],
      };
    },
    [CIRCLE]: function (coOrdinates, ev, circle = circleShape, cnt = count) {
      let cntZ = circle.zIndex || getHeightestZindex();
      setCountZindex(cntZ);
      let x = layerSequence("Shape");
      let layerCnt;
      if (x.length > 0) {
        layerCnt = getMaxlayerNameCount("Shape") + 1;
      } else {
        layerCnt = x.length + 1;
      }
      return {
        id: "circleShape" + cnt,
        componentType: "Shape",
        textComponentType: {
          addContent: "circleShape",
        },
        froalaText: "",
        componentStyles: {
          left: coOrdinates.x,
          top: coOrdinates.y,
          width: circle.width,
          height: circle.height,
          bottom: coOrdinates.y + circle.height,
          right: circle.width + coOrdinates.x,
          vMiddle: coOrdinates.x + circle.width / 2,
          hMiddle: coOrdinates.y + circle.height / 2,
          zIndex: cntZ,
          backgroundColor: circle.backgroundColor,
          border: circle.border,
          borderRadius: circle.borderRadius,
          icon: circle.icon,
          BGColor: "#ceb5b7",
          rotation: circle.rotation,
          aspectLock: isAspectRatioLocked,
          lockBoolean: circle.lockBoolean,
          hideBoolean: circle.hideBoolean,
          opacity: circle.hideBoolean ? 0 : 1,
          compOpacity: circle.compOpacity,
          layerName:
            circle.layerName === "Shape"
              ? circle.layerName + layerCnt
              : circle.layerName,
          layerNameUpdated:
            circle.layerName === "Shape"
              ? circle.layerName + layerCnt
              : circle.layerName,
          layerWidth: circle.layerWidth,
          transformOriginX: circle.transformOriginX,
          tranformOriginY: circle.transformOriginY,
          transformOriginZ: circle.transformOriginZ,
        },

        keyFrames: circle.keyFrames || [],
      };
    },
    [TRIANGLE]: function (
      coOrdinates,
      ev,
      triangle = triangleShape,
      cnt = count,
    ) {
      let cntZ = triangle.zIndex || getHeightestZindex();
      setCountZindex(cntZ);
      let x = layerSequence("Shape");
      let layerCnt;
      if (x.length > 0) {
        layerCnt = getMaxlayerNameCount("Shape") + 1;
      } else {
        layerCnt = x.length + 1;
      }
      return {
        id: "triangleShape" + cnt,
        componentType: "Shape",
        textComponentType: {
          addContent: "triangleShape",
        },
        froalaText: "",
        triImage: triangle.src,
        componentStyles: {
          left: coOrdinates.x,
          top: coOrdinates.y,
          width: triangle.width,
          height: triangle.height,
          bottom: coOrdinates.y + triangle.height,
          right: triangle.width + triangle.x,
          vMiddle: coOrdinates.x + triangle.width / 2,
          hMiddle: coOrdinates.y + triangle.height / 2,
          zIndex: cntZ,
          backgroundColor: triangle.backgroundColor,
          border: triangle.border,
          borderWidth: triangle.borderWidth,
          borderStyle: triangle.borderStyle,
          icon: triangle.icon,
          BGColor: "#ceb5b7",
          rotation: triangle.rotation,
          aspectLock: isAspectRatioLocked,
          lockBoolean: triangle.lockBoolean,
          hideBoolean: triangle.hideBoolean,
          opacity: triangle.hideBoolean ? 0 : 1,
          compOpacity: triangle.compOpacity,
          layerName:
            triangle.layerName === "Shape"
              ? triangle.layerName + layerCnt
              : triangle.layerName,
          layerNameUpdated:
            triangle.layerName === "Shape"
              ? triangle.layerName + layerCnt
              : triangle.layerName,
          layerWidth: triangle.layerWidth,
          transformOriginX: triangle.transformOriginX,
          tranformOriginY: triangle.transformOriginY,
          transformOriginZ: triangle.transformOriginZ,
        },

        keyFrames: triangle.keyFrames || [],
      };
    },
    [POLYGON]: function (coOrdinates, ev, polygon = polygonShape, cnt = count) {
      let cntZ = polygon.zIndex || getHeightestZindex();
      setCountZindex(cntZ);
      let x = layerSequence("Shape");
      let layerCnt;
      if (x.length > 0) {
        layerCnt = getMaxlayerNameCount("Shape") + 1;
      } else {
        layerCnt = x.length + 1;
      }
      return {
        id: "polygonShape" + cnt,
        componentType: "Shape",
        textComponentType: {
          addContent: "polygonShape",
        },
        froalaText: "",
        pentImage: polygon.src,
        componentStyles: {
          left: coOrdinates.x,
          top: coOrdinates.y,
          width: polygon.width,
          height: polygon.height,
          bottom: coOrdinates.y + polygon.height,
          right: polygon.width + polygon.x,
          vMiddle: coOrdinates.x + polygon.width / 2,
          hMiddle: coOrdinates.y + polygon.height / 2,
          zIndex: cntZ,
          border: polygon.border,
          backgroundColor: polygon.backgroundColor,
          icon: polygon.icon,
          BGColor: "#ceb5b7",
          rotation: polygon.rotation,
          aspectLock: isAspectRatioLocked,
          lockBoolean: polygon.lockBoolean,
          hideBoolean: polygon.hideBoolean,
          opacity: polygon.hideBoolean ? 0 : 1,
          compOpacity: polygon.compOpacity,
          layerName:
            polygon.layerName === "Shape"
              ? polygon.layerName + layerCnt
              : polygon.layerName,
          layerNameUpdated:
            polygon.layerName === "Shape"
              ? polygon.layerName + layerCnt
              : polygon.layerName,
          layerWidth: polygon.layerWidth,
          transformOriginX: polygon.transformOriginX,
          tranformOriginY: polygon.transformOriginY,
          transformOriginZ: polygon.transformOriginZ,
        },

        keyFrames: polygon.keyFrames || [],
      };
    },
    [HEXAGON]: function (coOrdinates, ev, hexa = hexagonShape, cnt = count) {
      let cntZ = hexa.zIndex || getHeightestZindex();
      setCountZindex(cntZ);
      let x = layerSequence("Shape");
      let layerCnt;
      if (x.length > 0) {
        layerCnt = getMaxlayerNameCount("Shape") + 1;
      } else {
        layerCnt = x.length + 1;
      }
      return {
        id: "hexagonShape" + cnt,
        componentType: "Shape",
        textComponentType: {
          addContent: "hexagonShape",
        },
        froalaText: "",
        hexImage: hexa.src,

        componentStyles: {
          left: coOrdinates.x,
          top: coOrdinates.y,
          width: hexa.width,
          height: hexa.height,
          bottom: coOrdinates.y + hexa.height,
          right: hexa.width + coOrdinates.x,
          vMiddle: coOrdinates.x + hexa.width / 2,
          hMiddle: coOrdinates.y + hexa.height / 2,
          zIndex: cntZ,
          border: hexa.border,
          backgroundColor: hexa.backgroundColor,
          icon: hexa.icon,
          BGColor: "#ceb5b7",
          rotation: hexa.rotation,
          aspectLock: isAspectRatioLocked,
          lockBoolean: hexa.lockBoolean,
          hideBoolean: hexa.hideBoolean,
          opacity: hexa.hideBoolean ? 0 : 1,
          compOpacity: hexa.compOpacity,
          layerName:
            hexa.layerName === "Shape"
              ? hexa.layerName + layerCnt
              : hexa.layerName,
          layerNameUpdated:
            hexa.layerName === "Shape"
              ? hexa.layerName + layerCnt
              : hexa.layerName,
          layerWidth: hexa.layerWidth,
          transformOriginX: hexa.transformOriginX,
          tranformOriginY: hexa.transformOriginY,
          transformOriginZ: hexa.transformOriginZ,
        },

        keyFrames: hexa.keyFrames || [],
      };
    },
    [SCROLLBAR]: function (
      coOrdinates,
      ev,
      rectangle = scrollbar,
      cnt = count,
    ) {
      let cntZ = rectangle.zIndex || getHeightestZindex();
      setCountZindex(cntZ);
      let x = layerSequence("Scrollbar");
      let layerCnt;
      if (x.length > 0) {
        layerCnt = getMaxlayerNameCount("Scrollbar") + 1;
      } else {
        layerCnt = x.length + 1;
      }
      return {
        id: "scrollbar" + cnt,
        componentType: "Scrollbar",
        textComponentType: {
          addContent: "scrollbar",
        },
        froalaText: "",
        componentStyles: {
          left: coOrdinates.x,
          top: coOrdinates.y,
          oldLeft: coOrdinates.x,
          oldRight: coOrdinates.y,
          width: rectangle.width,
          height: rectangle.height,
          scrollbarHeight: rectangle.height,
          bottom: coOrdinates.y + rectangle.height,
          right: rectangle.width + coOrdinates.x,
          vMiddle: coOrdinates.x + rectangle.width / 2,
          hMiddle: coOrdinates.y + rectangle.height / 2,
          zIndex: cntZ,
          backgroundColor: rectangle.backgroundColor,
          border: rectangle.border,
          paddingTop: rectangle.paddingTop,
          paddingRight: rectangle.paddingRight,
          paddingBottom: rectangle.paddingBottom,
          paddingLeft: rectangle.paddingLeft,
          borderTopLeftRadius: rectangle.borderTopLeftRadius,
          borderTopRightRadius: rectangle.borderTopRightRadius,
          borderBottomLeftRadius: rectangle.borderBottomLeftRadius,
          borderBottomRightRadius: rectangle.borderBottomRightRadius,
          icon: rectangle.icon,
          BGColor: "#ceb5b7",
          rotation: rectangle.rotation,
          aspectLock: isAspectRatioLocked,
          lockBoolean: rectangle.lockBoolean,
          hideBoolean: rectangle.hideBoolean,
          opacity: rectangle.hideBoolean ? 0 : 1,
          compOpacity: rectangle.compOpacity,
          layerName:
            rectangle.layerName === "Scrollbar"
              ? rectangle.layerName + layerCnt
              : rectangle.layerName,
          layerNameUpdated:
            rectangle.layerName === "Scrollbar"
              ? rectangle.layerName + layerCnt
              : rectangle.layerName,
          layerWidth: rectangle.layerWidth,
          transformOriginX: rectangle.transformOriginX,
          transformOriginY: rectangle.transformOriginY,
          transformOriginZ: rectangle.transformOriginZ,
          scrollBorderRadius: rectangle.scrollBorderRadius,
          scrollThumbColor: rectangle.scrollThumbColor,
          scrollThumbBgColor: rectangle.scrollThumbBgColor,
        },
        scrollbarComponents: [],
        keyFrames: rectangle.keyFrames || [],
      };
    },
    [REFERENCE]: function (coOrdinates, ev, ref = reference, cnt = count) {
      let cntZ = ref.zIndex || getHeightestZindex();
      setCountZindex(cntZ);
      let x = layerSequence("Reference");
      let layerCnt;
      if (x.length > 0) {
        layerCnt = getMaxlayerNameCount("Reference") + 1;
      } else {
        layerCnt = x.length + 1;
      }

      return {
        id: "Reference" + cnt,
        componentType: "Text",
        textComponentType: {
          addContent: "Reference",
        },
        reference: true,
        froalaText: ref.froalaText,
        componentStyles: {
          left: coOrdinates.x,
          top: coOrdinates.y,
          width: ref.width,
          height: ref.height,
          bottom: ref.height + coOrdinates.y,
          right: ref.width + coOrdinates.x,
          vMiddle: ref.x + ref.width / 2,
          hMiddle: coOrdinates.y + ref.height / 2,
          fontFamily: ref.fontFamily,
          fontLink: ref.fontLink || "",
          fontSize: ref.fontSize,

          textAlign: ref.textAlign,
          color: ref.color,
          listStyletype: ref.listStyletype,
          fontWeight: ref.fontWeight,
          fontWeightBold: ref.fontWeightBold,
          textDecUnderline: ref.textDecUnderline,
          letterSpacing: ref.letterSpacing,
          lineHeight: ref.lineHeight,
          fontStyle: ref.fontStyle,
          textTransform: ref.textTransform,
          textDecoration: ref.textDecoration,
          underlineClick: ref.underlineClick,
          strikeThroughClicked: ref.strikeThroughClicked,
          italicClick: ref.italicClick,
          boldClick: ref.boldClick,
          uppercaseClicked: ref.uppercaseClicked,
          zIndex: cntZ,
          icon: ref.icon,
          BGColor: "#a9e4bc",
          rotation: ref.rotation,
          ease: ref.ease,
          targetLink: ref.targetLink,
          aspectLock: isAspectRatioLocked,
          lockBoolean: ref.lockBoolean,
          hideBoolean: ref.hideBoolean,
          opacity: ref.hideBoolean ? 0 : 1,
          toggleScroll: ref.toggleScroll,
          thumbHeight: ref.thumbHeight,
          thumbWidth: ref.thumbWidth,
          arrowWidth: ref.arrowWidth,
          arrowHeight: ref.arrowHeight,
          trackWidth: ref.trackWidth,
          trackHeight: ref.trackHeight,
          trackRadius: ref.trackRadius,
          thumbColor: ref.thumbColor,
          scrollThumbBg: ref.scrollThumbBg,
          scrollUpArrowbg: ref.scrollUpArrowbg,
          scrollDownArrowbg: ref.scrollDownArrowbg,
          textBgColor: ref.textBgColor,
          datafontSize: ref.datafontSize,
          selectedFontStyle: ref.selectedFontStyle,
          selectedId: ref.selectedId,
          selectedIdnumberList: ref.selectedIdnumberList,

          autoScroll: ref.autoScroll,
          expandAndClose: ref.expandAndClose,
          expandText: ref.expandText,
          closeText: ref.closeText,
          thumbRight: ref.thumbRight,
          trackRight: ref.trackRight,
          expandTextUpdated: ref.expandText,
          closeTextUpdated: ref.closeText,
          expandClose: { ...ref.expandClose },
          layerName:
            ref.layerName === "Text" ? ref.layerName + layerCnt : ref.layerName,
          thumbRight: ref.thumbRight,
          layerNameUpdated:
            ref.layerName === "Text" ? ref.layerName + layerCnt : ref.layerName,
          layerWidth: ref.layerWidth,
          transformOriginX: ref.transformOriginX,
          tranformOriginY: ref.transformOriginY,
          transformOriginZ: ref.transformOriginZ,
        },

        keyFrames: ref.keyFrames || [],
      };
    },
    [FOOTNOTES]: function (coOrdinates, ev, fNotes = footnotes, cnt = count) {
      let cntZ = fNotes.zIndex || getHeightestZindex();
      setCountZindex(cntZ);
      let x = layerSequence("Footnotes");
      let layerCnt;
      if (x.length > 0) {
        layerCnt = getMaxlayerNameCount("Footnotes") + 1;
      } else {
        layerCnt = x.length + 1;
      }

      return {
        id: "Footnotes" + cnt,
        footnotes: true,
        componentType: "Text",
        textComponentType: {
          addContent: "Footnotes",
        },
        froalaText: fNotes.froalaText,
        componentStyles: {
          left: coOrdinates.x,
          top: coOrdinates.y + 40,
          width: fNotes.width,
          height: fNotes.height,
          bottom: fNotes.height + coOrdinates.y,
          right: fNotes.width + coOrdinates.x,
          vMiddle: fNotes.x + fNotes.width / 2,
          hMiddle: coOrdinates.y + fNotes.height / 2,
          fontFamily: fNotes.fontFamily,
          fontLink: fNotes.fontLink || "",
          fontSize: fNotes.fontSize,
          textAlign: fNotes.textAlign,
          color: fNotes.color,
          listStyletype: fNotes.listStyletype,
          fontWeight: fNotes.fontWeight,
          fontWeightBold: fNotes.fontWeightBold,
          textDecUnderline: fNotes.textDecUnderline,
          letterSpacing: fNotes.letterSpacing,
          lineHeight: fNotes.lineHeight,
          fontStyle: fNotes.fontStyle,
          textTransform: fNotes.textTransform,
          textDecoration: fNotes.textDecoration,
          underlineClick: fNotes.underlineClick,
          strikeThroughClicked: fNotes.strikeThroughClicked,
          italicClick: fNotes.italicClick,
          boldClick: fNotes.boldClick,
          uppercaseClicked: fNotes.uppercaseClicked,
          zIndex: cntZ,
          icon: fNotes.icon,
          BGColor: "#a9e4bc",
          rotation: fNotes.rotation,
          ease: fNotes.ease,
          targetLink: fNotes.targetLink,
          aspectLock: isAspectRatioLocked,
          lockBoolean: fNotes.lockBoolean,
          hideBoolean: fNotes.hideBoolean,
          opacity: fNotes.hideBoolean ? 0 : 1,
          toggleScroll: fNotes.toggleScroll,
          thumbHeight: fNotes.thumbHeight,
          thumbWidth: fNotes.thumbWidth,
          arrowWidth: fNotes.arrowWidth,
          arrowHeight: fNotes.arrowHeight,
          trackWidth: fNotes.trackWidth,
          trackHeight: fNotes.trackHeight,
          trackRadius: fNotes.trackRadius,
          thumbColor: fNotes.thumbColor,
          scrollThumbBg: fNotes.scrollThumbBg,
          scrollUpArrowbg: fNotes.scrollUpArrowbg,
          scrollDownArrowbg: fNotes.scrollDownArrowbg,
          textBgColor: fNotes.textBgColor,
          datafontSize: fNotes.datafontSize,
          selectedFontStyle: fNotes.selectedFontStyle,
          selectedId: fNotes.selectedId,
          selectedIdnumberList: fNotes.selectedIdnumberList,
          autoScroll: fNotes.autoScroll,
          expandAndClose: fNotes.expandAndClose,
          expandText: fNotes.expandText,
          closeText: fNotes.closeText,
          thumbRight: fNotes.thumbRight,
          trackRight: fNotes.trackRight,
          expandTextUpdated: fNotes.expandText,
          closeTextUpdated: fNotes.closeText,
          expandClose: { ...fNotes.expandClose },
          layerName:
            fNotes.layerName === "Text"
              ? fNotes.layerName + layerCnt
              : fNotes.layerName,
          thumbRight: fNotes.thumbRight,
          layerNameUpdated:
            fNotes.layerName === "Text"
              ? fNotes.layerName + layerCnt
              : fNotes.layerName,
          layerWidth: fNotes.layerWidth,
          transformOriginX: fNotes.transformOriginX,
          tranformOriginY: fNotes.transformOriginY,
          transformOriginZ: fNotes.transformOriginZ,
        },
        keyFrames: fNotes.keyFrames || [],
      };
    },
    [ABBREVIATION]: function (
      coOrdinates,
      ev,
      abbreviationObj = abbreviation,
      cnt = count,
    ) {
      let cntZ = abbreviationObj.zIndex || getHeightestZindex();
      setCountZindex(cntZ);
      let x = layerSequence("Abbreviation");
      let layerCnt;
      if (x.length > 0) {
        layerCnt = getMaxlayerNameCount("Abbreviation") + 1;
      } else {
        layerCnt = x.length + 1;
      }

      return {
        id: "abbreviation" + cnt,
        abbreviation: true,
        componentType: "Text",
        textComponentType: {
          addContent: "Abbreviation",
        },
        froalaText: abbreviationObj.froalaText,
        componentStyles: {
          left: coOrdinates.x,
          top: coOrdinates.y + 20,
          width: abbreviationObj.width,
          height: abbreviationObj.height,
          bottom: abbreviationObj.height + coOrdinates.y,
          right: abbreviationObj.width + coOrdinates.x,
          vMiddle: abbreviationObj.x + abbreviationObj.width / 2,
          hMiddle: coOrdinates.y + abbreviationObj.height / 2,
          fontFamily: abbreviationObj.fontFamily,
          fontLink: abbreviationObj.fontLink || "",
          fontSize: abbreviationObj.fontSize,
          textAlign: abbreviationObj.textAlign,
          color: abbreviationObj.color,
          listStyletype: abbreviationObj.listStyletype,
          fontWeight: abbreviationObj.fontWeight,
          fontWeightBold: abbreviationObj.fontWeightBold,
          textDecUnderline: abbreviationObj.textDecUnderline,
          letterSpacing: abbreviationObj.letterSpacing,
          lineHeight: abbreviationObj.lineHeight,
          fontStyle: abbreviationObj.fontStyle,
          textTransform: abbreviationObj.textTransform,
          textDecoration: abbreviationObj.textDecoration,
          underlineClick: abbreviationObj.underlineClick,
          strikeThroughClicked: abbreviationObj.strikeThroughClicked,
          italicClick: abbreviationObj.italicClick,
          boldClick: abbreviationObj.boldClick,
          uppercaseClicked: abbreviationObj.uppercaseClicked,
          zIndex: cntZ,
          icon: abbreviationObj.icon,
          BGColor: "#a9e4bc",
          rotation: abbreviationObj.rotation,
          ease: abbreviationObj.ease,
          targetLink: abbreviationObj.targetLink,
          aspectLock: isAspectRatioLocked,
          lockBoolean: abbreviationObj.lockBoolean,
          hideBoolean: abbreviationObj.hideBoolean,
          opacity: abbreviationObj.hideBoolean ? 0 : 1,
          toggleScroll: abbreviationObj.toggleScroll,
          thumbHeight: abbreviationObj.thumbHeight,
          thumbWidth: abbreviationObj.thumbWidth,
          arrowWidth: abbreviationObj.arrowWidth,
          arrowHeight: abbreviationObj.arrowHeight,
          trackWidth: abbreviationObj.trackWidth,
          trackHeight: abbreviationObj.trackHeight,
          trackRadius: abbreviationObj.trackRadius,
          thumbColor: abbreviationObj.thumbColor,
          scrollThumbBg: abbreviationObj.scrollThumbBg,
          scrollUpArrowbg: abbreviationObj.scrollUpArrowbg,
          scrollDownArrowbg: abbreviationObj.scrollDownArrowbg,
          textBgColor: abbreviationObj.textBgColor,
          datafontSize: abbreviationObj.datafontSize,
          selectedFontStyle: abbreviationObj.selectedFontStyle,
          selectedId: abbreviationObj.selectedId,
          selectedIdnumberList: abbreviationObj.selectedIdnumberList,
          autoScroll: abbreviationObj.autoScroll,
          expandAndClose: abbreviationObj.expandAndClose,
          expandText: abbreviationObj.expandText,
          closeText: abbreviationObj.closeText,
          thumbRight: abbreviationObj.thumbRight,
          trackRight: abbreviationObj.trackRight,
          expandTextUpdated: abbreviationObj.expandText,
          closeTextUpdated: abbreviationObj.closeText,
          expandClose: { ...abbreviationObj.expandClose },
          layerName:
            abbreviationObj.layerName === "Text"
              ? abbreviationObj.layerName + layerCnt
              : abbreviationObj.layerName,
          thumbRight: abbreviationObj.thumbRight,
          layerNameUpdated:
            abbreviationObj.layerName === "Text"
              ? abbreviationObj.layerName + layerCnt
              : abbreviationObj.layerName,
          layerWidth: abbreviationObj.layerWidth,
          transformOriginX: abbreviationObj.transformOriginX,
          tranformOriginY: abbreviationObj.transformOriginY,
          transformOriginZ: abbreviationObj.transformOriginZ,
        },
        keyFrames: abbreviationObj.keyFrames || [],
      };
    },
    default: function () {
      return;
    },
    Conatiner: function () {
      return;
    },
  };

  return componentType;
};
